export default __webpack_public_path__ + "static/media/drone-border.1aeaec9d.jpg";